import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer1">
        <div className="footer2">
          <p>© 2024 Global Innovation Technologies. All rights reserved.</p>
        </div>
        <div className="footer3">
          <p>Contact Phone : +91 9606403559 Maps&Directions</p>
          <p>FeedBack</p>
        </div>
        <div className="footer4">

          <a href="https://www.instagram.com/global_innovation_technologie?igsh=NjVxc2UzbXZ1cXVs">
            <div className="insta"> </div>
          </a>

          <a href="https://www.facebook.com/share/18Zo7FcA5d/">

            <div className="face">

            </div>
          </a>

          <a href="https://youtube.com/@globalinnovationtechnologi6841?si=lFWdypZuCDVh2ljB">
          <div className="link">

          </div></a>
          
         

        </div>
      </div>
    </footer>
  );
};

export default Footer;
